"use strict";

var _interopRequireDefault = require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classNames = _interopRequireDefault(require("../classNames"));
var _react = _interopRequireDefault(require("react"));
var _checkCondition = _interopRequireDefault(require("../checkCondition"));
var _hasAccess = _interopRequireDefault(require("../hasAccess"));
var _jsxFileName = "/Users/john/Desktop/Projects/nq-component/src/FormFactory/FormTab.js";
var noop = function noop() {};
var defaultProps = {
  onSet: noop
};
function FormTab(_ref) {
  var _this = this;
  var tabs = _ref.tabs,
    onSet = _ref.onSet,
    object = _ref.object,
    roles = _ref.roles;
  if (tabs === undefined) return null;
  return /*#__PURE__*/_react["default"].createElement("nav", {
    className: "col-12 mb-3",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "nav nav-tabs",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 13
    }
  }, Object.keys(tabs).map(function (key, index) {
    var label = tabs[key].label;
    var conditions = tabs[key]["if"] || tabs[key].or || tabs[key].and;
    if (conditions && !(0, _checkCondition["default"])(tabs[key], object)) {
      return null;
    }
    if (!(0, _hasAccess["default"])(roles, tabs[key].access)) {
      return null;
    }
    return /*#__PURE__*/_react["default"].createElement("button", {
      onClick: function onClick() {
        return onSet(key);
      },
      className: (0, _classNames["default"])("nav-link", index === 0 ? "active" : ""),
      "data-bs-toggle": "tab",
      "data-bs-target": "#nav-moodle",
      type: "button",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 29,
        columnNumber: 29
      }
    }, label || key);
  })));
}
FormTab.defaultProps = defaultProps;
var _default = exports["default"] = FormTab;